export default __webpack_public_path__ + "static/media/destiny2shadowkeep.674c3015.jpg";